import React, { useState, useRef, useEffect } from 'react';
import './App.css';
import MacComputer from './components/MacComputer';
import StartupSequence from './components/StartupSequence';
import StandaloneApp from './components/StandaloneApp';
import { AuthProvider } from './contexts/AuthContext';
import bootupAudio from './sounds/bootup.mp3';

function App() {
  const [isStartupComplete, setIsStartupComplete] = useState(false);
  const [initialRoute, setInitialRoute] = useState<string>('');
  const [standaloneAppId, setStandaloneAppId] = useState<string | null>(null);
  const audioRef = useRef<HTMLAudioElement | null>(null);

  useEffect(() => {
    // Capture the initial route when app loads
    const path = window.location.pathname;
    setInitialRoute(path);
    
    // Check if this is a standalone app route: /app/[appId]
    const appMatch = path.match(/^\/app\/([a-z0-9-]+)$/i);
    if (appMatch) {
      setStandaloneAppId(appMatch[1]);
    }
  }, []);

  const handleStartupComplete = () => {
    setIsStartupComplete(true);
  };

  const playStartupAudio = () => {
    if (audioRef.current) {
      audioRef.current.play().catch(err => console.log("Audio play error:", err));
    }
  };

  // Fast fade-out for when the startup sequence is skipped (double-tap).
  const fadeOutStartupAudio = () => {
    const audio = audioRef.current;
    if (!audio) return;
    const iv = setInterval(() => {
      if (audio.volume > 0.08) {
        audio.volume = Math.max(0, audio.volume - 0.08);
      } else {
        audio.volume = 0;
        audio.pause();
        clearInterval(iv);
      }
    }, 30);
  };

  // Render standalone app page (no Mac emulator)
  if (standaloneAppId) {
    return (
      <AuthProvider>
        <StandaloneApp appId={standaloneAppId} />
      </AuthProvider>
    );
  }

  return (
    <AuthProvider>
      <div className="App">
        {/* Audio element persists across component transitions */}
        <audio ref={audioRef} src={bootupAudio} preload="auto" />

        {!isStartupComplete && (
          <StartupSequence
            onComplete={handleStartupComplete}
            onStartAudio={playStartupAudio}
            onStopAudio={fadeOutStartupAudio}
            initialRoute={initialRoute}
          />
        )}
        {isStartupComplete && <MacComputer initialRoute={initialRoute} />}
      </div>
    </AuthProvider>
  );
}

export default App;
